import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import moment from "moment";
import {Calendar} from "primereact/calendar";
import _FM_GroupCustomersComponent from "./_FM_GroupCustomersComponent";

const _FM_GroupFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [accommodation, setAccommodation] = useState([]);
  const [reservationChannel, setReservationChannel] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [reservedFromDate, setReservedFromDate] = useState();
  const [reservedFromTime, setReservedFromTime] = useState('15:00');
  const [reservedToDate, setReservedToDate] = useState();
  const [reservedToTime, setReservedToTime] = useState('10:00');
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const _fromDatePart = moment.utc(reservedFromDate).local().format('YYYY-MM-DD');
    const _fromTimePart = reservedFromTime;
    const [_fromHour, _fromMinute] = _fromTimePart.split(":");
    const _fromAdjustedHour = (parseInt(_fromHour, 10) - 1).toString().padStart(2, "0");
    const _fromAdjustedTimePart = `${_fromAdjustedHour}:${_fromMinute}`;
    const _fromCombinedString = `${_fromDatePart}T${_fromAdjustedTimePart}:00Z`;
    const _fromUtcDate = new Date(_fromCombinedString);
    const _toDatePart = moment.utc(reservedToDate).local().format('YYYY-MM-DD');
    const _toTimePart = reservedToTime;
    const [_toHour, _toMinute] = _toTimePart.split(":");
    const _toAdjustedHour = (parseInt(_toHour, 10) - 1).toString().padStart(2, "0");
    const _toAdjustedTimePart = `${_toAdjustedHour}:${_toMinute}`;
    const _toCombinedString = `${_toDatePart}T${_toAdjustedTimePart}:00Z`;
    const _toUtcDate = new Date(_toCombinedString);
    data = {
      ...data,
      from: _fromUtcDate,
      to: _toUtcDate
    }
    let newData = {
      ...newFormData,
      from: _fromUtcDate,
      to: _toUtcDate
    }
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "group/" + formData.id,
        newData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderGroupList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            if (props.onClose) {
              props.onClose();
            } else {
              navigate(-1)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "group",
        data,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderGroupList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            if (props.onClose) {
              props.onClose();
            } else {
              navigate(-1)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    if (formData.from) {
      let dateString = formData.from.toString();
      let date = new Date(dateString);
      let formattedDate = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
      let formattedTime = `${String(date.getUTCHours() + 1).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
      setReservedFromDate(moment.utc(formattedDate).local().format(t('YYYY-MM-DD')))
      setReservedFromTime(formattedTime)
    }
  }, [formData.from])

  useEffect(() => {
    if (formData.to) {
      let dateString = formData.to.toString()
      let date = new Date(dateString);
      let formattedDate = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
      let formattedTime = `${String(date.getUTCHours() + 1).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
      setReservedToDate(moment.utc(formattedDate).local().format(t('YYYY-MM-DD')))
      setReservedToTime(formattedTime)
    }
  }, [formData.to])

  useEffect(() => {
    const groupId = props.groupId ?? window.App.urlVars().groupId ?? id;
    if (groupId) {
      setLoading(true)
      apiCall('get', 'group/' + groupId)
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    apiCall('get', 'accommodation')
      .then(response => {
        setAccommodation(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'reservation-channel')
      .then(response => {
        setLoading(false)
        setReservationChannel(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/currency')
      .then(response => {
        const allCurrencies = response.data.data;
        const prioritizedCurrencies = JSON.parse(process.env.REACT_APP_PRIORITIZEDCURRENCIES || "[]");
        const sortedCurrencies = [
          ...allCurrencies.filter((currency) => prioritizedCurrencies.includes(currency.code)),
          ...allCurrencies.filter((currency) => !prioritizedCurrencies.includes(currency.code)),
        ];
        setCurrencies(sortedCurrencies);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/country')
      .then(response => {
        const allCountries = response.data.data;
        const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
        const sortedCountries = [
          ...allCountries.filter((country) => prioritizedCountries.includes(country.code)),
          ...allCountries.filter((country) => !prioritizedCountries.includes(country.code)),
        ];
        setCountries(sortedCountries);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [id, props.groupId, window.App.state.rerenderGroupList, window.App.state.rerenderCustomerList])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('group_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-12"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="accommodation" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"accommodation"}/>
                      <label htmlFor="accommodation"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('accommodation')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={accommodation}
                                  optionLabel="name"
                                  optionValue="id"
                                  filter
                                  id={"accommodation"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      accommodation: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      accommodation: e.value
                                    })
                                  }}
                                  value={formData.accommodation?.id || formData.accommodation}
                        />
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="reservation_channel" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"reservation_channel"}/>
                      <label htmlFor="reservation_channel"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('channel')}</label>
                      <span className="">
                          <Dropdown  options={reservationChannel}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"reservation_channel"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        reservation_channel: e.value,
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        reservation_channel: e.value,
                                      })
                                    }}
                                    value={formData?.reservation_channel?.id || formData.reservation_channel}
                          />
                        </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="currency" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"currency"}/>
                      <label htmlFor="currency"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('currency')}</label>
                      <span className="p-d-block">
                      <Dropdown  options={currencies}
                                filter
                                disabled={formData.id}
                                optionLabel="code"
                                optionValue="code"
                                id={"currency"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    currency: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    currency: e.value
                                  })
                                }}
                                value={formData.currency}
                                showClear
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="from" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"from"}/>
                      <label htmlFor="from"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('reserved_from')} - {t('reserved_to')}</label>
                      <Calendar
                        id={"from"}
                        value={reservedFromDate ? [
                          moment(reservedFromDate, 'YYYY-MM-DD').toDate(),
                          reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null
                        ] : null}
                        locale="default"
                        dateFormat={t('YY-MM-DD')}
                        selectionMode="range"
                        showIcon
                        onChange={(e) => {
                          setReservedFromDate(e.value?.[0] ? moment.utc(e.value[0]).local().format(t('YYYY-MM-DD')) : null)
                          setReservedToDate(e.value?.[1] ? moment.utc(e.value[1]).local().format(t('YYYY-MM-DD')) : null)
                        }}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="contact_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"contact_name"}/>
                      <label htmlFor="contact_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_name')}</label>
                      <span className="p-d-block">
                      <InputText id="contact_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_name: e.target.value
                                   })
                                 }}
                                 value={formData.contact_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="contact_email" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"contact_email"}/>
                      <label htmlFor="contact_email"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_email')}</label>
                      <span className="p-d-block">
                      <InputText id="contact_email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_email: e.target.value
                                   })
                                 }}
                                 value={formData.contact_email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="contact_phone" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"contact_phone"}/>
                      <label htmlFor="contact_phone"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_phone')}</label>
                      <span className="p-d-block">
                      <InputText id="contact_phone" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_phone: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_phone: e.target.value
                                   })
                                 }}
                                 value={formData.contact_phone}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="contact_nationality" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"contact_nationality"}/>
                      <label htmlFor="contact_nationality"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_nationality')}</label>
                      <span className="p-d-block">
                      <Dropdown  options={countries}
                                filter
                                optionLabel="name"
                                optionValue="code"
                                id={"contact_nationality"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    contact_nationality: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    contact_nationality: e.value
                                  })
                                }}
                                value={formData.contact_nationality}
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="company_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"company_name"}/>
                      <label htmlFor="company_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('company_name')}</label>
                      <span className="p-d-block">
                      <InputText id="company_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     company_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     company_name: e.target.value
                                   })
                                 }}
                                 value={formData.company_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
        <BlockUI blocked={!formData.id} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
          <Panel className={"p-mt-3"}>
            {/*
              Pass reserved period in explicit datetime format for manual distribute URL params.
            */}
            <_FM_GroupCustomersComponent customers={formData?.customers} groupId={formData.id}
                                         accommodationId={formData?.accommodation?.id || formData?.accommodation}
                                         isDistributed={Boolean(formData?.is_distibuted ?? formData?.is_distributed)}
                                         reservedFrom={reservedFromDate && reservedFromTime ? moment(`${reservedFromDate} ${reservedFromTime}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss') : ''}
                                         reservedTo={reservedToDate && reservedToTime ? moment(`${reservedToDate} ${reservedToTime}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss') : ''}/>
          </Panel>
        </BlockUI>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_GroupFormComponent);
